// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Es6Promise from "es6-promise";
import "./element-variables.scss";
import ElementUI, { MessageBox, Message } from "element-ui";
import Axios from "axios";

Es6Promise.polyfill();

Vue.use(ElementUI);
// Vue.use(MessageBox);
// Vue.use(Message);

//全局注册
Vue.prototype.axios = Axios;

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;


Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    store,
    template: "<App/>",
    components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js